import { render } from "./FormateurPage.vue?vue&type=template&id=7109bd95"
import script from "./FormateurPage.vue?vue&type=script&lang=js"
export * from "./FormateurPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__